module.exports = __webpack_public_path__ + "static/media/drugFree.10d15dec.png";